<template>
  <div class="BindCard">
    <Form :model="form" :rules="rules" v-model="regular">
        <Input
          label="授信合同编号"
          v-model="form.contractNo"
          :reg="rules.contractNo"
          maxlength="20"
          labelWidth="90px"
          type="tel"
          :readonly="true"
          placeholder="请输入授信合同编号"
        />
      <Input
        label="旧还款卡号"
        type="tel"
        v-model="form.oldCardNo"
        :reg="rules.oldCardNo"
        labelWidth="90px"
        :readonly="true"
        maxlength="20"
        placeholder="请输入旧还款卡号"
      />
      <Input
        label="新还款卡号"
        type="tel"
        v-model="form.newCardNo"
        :reg="rules.newCardNo"
        labelWidth="90px"
        maxlength="20"
        placeholder="请输入您的浦发一类银行卡号"
      />
      <Input
        label="手机号"
        type="tel"
        v-model="form.custMobile"
        :reg="rules.custMobile"
        labelWidth="90px"
        maxlength="11"
        :readonly="true"
        placeholder="请输入手机号"
      />
      <message-code
        label="短信验证"
        :reg="rules.randomPassword"
        placeholder="请输入验证码"
        v-model="form.randomPassword"
        :params="{
          cust_mobile: form.custMobile,
          biz_scene: '105324',
        }"
      ></message-code>
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="提交"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />
    <self-popup v-model="ShowContent"></self-popup>
  </div>
</template>

<script>
import Input from '@/components/Input.vue';
import Form from '@/components/Form.vue';
import Button from '@/components/Button.vue';
import { mapState, mapMutations } from 'vuex';
import MessageCode from '@/components/MessageCode.vue';
import { rules } from '@/utils';

export default {
  name: 'ChangeCardNumber',
  components: {
    Button,
    Input,
    Form,
    MessageCode,
  },
  data() {
    return {
      showBankProps: false,
      banklist: [],
      regular: false,
      loading: false,
      ShowContent: '',
      uuid: '',
      form: {
        contractNo: '',
        oldCardNo: '',
        newCardNo: '',
        custMobile: '',
        randomPassword: '',
      },
      rules: {
        contractNo: rules.bankNumber,
        oldCardNo: rules.bankNumber,
        newCardNo: rules.bankNumber,
        custMobile: rules.legalPhone,
        randomPassword: rules.captcha,
      },
    };
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
  },

  methods: {
    ...mapMutations('capitalAccount', ['updateState']),
    nextStep() {
      this.loading = true;
      this.regular = false;
      const params = {
        ...this.form,
        orderId: this.capitalAccount.orderId,
      };
      this.$api.CommonForms.addBindNewCard(params)
        .then(async (res) => {
          if (res.success) {
            this.uuid = res.data.uuid;
          } else {
            this.ShowContent = res.returnMessage;
            this.loading = false;
            this.regular = true;
          }
        })
        .catch((e) => {
          this.regular = true;
          this.ShowContent = e;
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.supportBox {
  position: relative;
}
.bankSupport {
  background: #fff;
  position: absolute;
  right: 16px;
  top: 10px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #ff6538;
}
.BindCard >>> .van-field__label {
  text-align: left;
}
.nextStep {
  margin-top: 16px;
}
.BindCard >>> .van-button--danger {
  color: #fff;
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border: none !important;
}
.BindCard >>> .van-button--disabled{
  border: none !important;
}
.BindCard >>> .van-field__body > input {
  width: 174px;
}
>>> .label{
  margin-right: 9px;
}
</style>
